import Unfalldesk from './Unfalldesk.vue';
import UnfalldeskHeader from './UnfalldeskHeader.vue';
import moduleId from './moduleId';
import store from '@/store/index';

class UnfallDeskRouteHandler {
  getRoutes = ({ moduleType }) => {
    return [
      {
        path: '/unfalldesk',
        name: 'unfalldesk',
        meta: { moduleType, initiateSyncBeforeNav: true, moduleId, baseRoute: true },
        components: { default: Unfalldesk, header: UnfalldeskHeader },
      },
      {
        path: '/unfalldesk/:instance',
        name: 'unfalldeskWithInstance',
        meta: { moduleType, initiateSyncBeforeNav: true, moduleId, baseRoute: true },
        components: { default: Unfalldesk, header: UnfalldeskHeader },
      },
    ];
  };
  /**
   * Optional method called in beforeEach
   * @param {object} moduleState the vuex state of the current module
   * @param {object} moduleConfig the module configuration where the user tries to navigate to
   * @param {object} from previous route
   * @param {object} to next route
   * @param {function} next function provided by vue router. Can be called to continue at a later stage.
   * @returns {shouldContinue} when shouldContinue is true, the router navigates to the next route (=to)
   */
  beforeNavigationFrom({ moduleState, moduleConfig, from, to, next }) {
    let shouldContinue = true;
    if (Object.keys(store.state.unfalldesk.formInput).length > 0 && !to.path.includes('unfalldesk')) {
      store.commit('unfalldesk/toggleCloseDialog', true);
      store.commit('unfalldesk/setToRoute', to);
      shouldContinue = false;
    }
    return { shouldContinue };
  }
}
const routeHandler = new UnfallDeskRouteHandler();
export default routeHandler;
